module.exports = __webpack_public_path__ + "img/linux.19368cc.png";